export default {
    'SEARCH.PAGE.TITLE': 'Que recherchez vous ?',
    'SEARCH.PAGE.INPUT.PLACEHOLDER': 'Tapez votre recherche ici',
};
